import { useMemo } from 'react';

import { CustomComponent } from '../custom';

import { NavbarViewProps } from './type';

export const NavbarViewV1: React.FC<NavbarViewProps> = ({
  leftComponent,
  rightComponent,
}) => {
  const defaultLeftComponent = useMemo(
    () => ({
      onlyChildren: true,
      children: <img src="/images/logo-black.svg" alt="logo" width={'130'} />,
    }),
    [],
  );

  return (
    <>
      {/* DEFAULT IS CF LOGO */}
      {leftComponent !== 'empty' && (
        <CustomComponent {...(leftComponent ?? defaultLeftComponent)} />
      )}

      {rightComponent !== 'empty' && <CustomComponent {...rightComponent} />}
    </>
  );
};
